'use client';

import dynamic from 'next/dynamic';
import CMSRouteParamsProvider from '@/global-state/cmsRouteParams/CMSRouteParamsProvider';

const DynamicProductsByMaterial = dynamic(
  () =>
    import(
      '@/joystagram-components/components/consumer/products-by-material'
    ).then(mod => mod.default),
  { ssr: false }
);

export default function SwatchPageClient({ fabricSlug }) {
  const path = `swatches/swatch/${fabricSlug}`;
  const routeKey = 'swatches/swatch/:swatch';

  return (
    <CMSRouteParamsProvider path={path} routeKey={routeKey}>
      <DynamicProductsByMaterial />
    </CMSRouteParamsProvider>
  );
}
